import { withInstall } from '@hd-front-end/utils'
import Drawer from './src/drawer.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElDrawer: SFCWithInstall<typeof Drawer> = withInstall(Drawer)
export default ElDrawer

export * from './src/drawer'
